// extracted by mini-css-extract-plugin
export var item = "style-module--item--b50c8";
export var link = "style-module--link--3996f";
export var list = "style-module--list--66aeb";
export var main = "style-module--main--23223";
export var message = "style-module--message--2f600";
export var name = "style-module--name--b24bb";
export var section = "style-module--section--87026";
export var tag = "style-module--tag--bf8d4";
export var tags = "style-module--tags--4a530";
export var videos = "style-module--videos--6acfb";